<template>
  <div class="row mt-3 mb-3">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              :to="{ name: 'travelExpensesPendingAndActiveList'}"
              :class="{ active: $route.name === 'travelExpensesPendingAndActiveList'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Ausstehende Anträge
          </router-link>
          <router-link
              :to="{ name: 'travelExpensesApprovedList'}"
              :class="{ active: $route.name === 'travelExpensesApprovedList'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Genehmigte Anträge
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>